import React, {Component} from "react";
import {Route, Switch} from "react-router-dom";
import TableOrder from "../Components/POS/TableOrder";
import CompanyMenu from "../Components/POS/CompanyMenu";
import CompanyList from "../Components/POS/CompanyList";
import Error404 from "../Components/Error404";
import KotBill from "../Components/POS/KotBill";

export default class POS extends Component {
  constructor(props) {
    super(props);
    this.state = {
      baseUrl: props.match.url,
    };
  }
  render() {
    return (
      <Switch>
        <Route path={`${this.state.baseUrl}`} exact component={CompanyList} />
        <Route
          path={`${this.state.baseUrl}/Order/:company/:id/:table`}
          exact
          component={TableOrder}
        />
        <Route
          path={`${this.state.baseUrl}/Menu/:company/:id`}
          exact
          component={CompanyMenu}
        />
        <Route
          path={`${this.state.baseUrl}/KotBill/:company/:id/:billno`}
          exact
          component={KotBill}
        />
        <Route path="*" component={Error404} />
      </Switch>
    );
  }
}
